// For request types see app/models/partners/health_metrics.rb.CONNECTION_REQUEST_TYPES
export const requestTypes = Object.freeze([
  { id: "all", label: "All requests" },
  { id: "users", label: "Users" },
  { id: "actions", label: "Actions" },
  { id: "queries", label: "Queries" },
  { id: "applets", label: "Connections" },
  { id: "field_options", label: "Field Dropdown Options" },
  { id: "webhooks", label: "Webhooks" },
])

// For response statuses see app/models/partners/health_metrics.rb.RESPONSE_STATUSES
export const responseStatuses = Object.freeze([
  { id: "all", label: "All statuses" },
  { id: "1xx", label: "Information (1xx)" },
  { id: "2xx", label: "Success (2xx)" },
  { id: "3xx", label: "Redirection (3xx)" },
  { id: "4xx", label: "Client error (4xx)" },
  { id: "5xx", label: "Server error (5xx)" },
  { id: "other", label: "Other" },
])

// For timeframes see app/models/partners/health_metrics.rb.TIMEFRAMES
export const timeframes = Object.freeze([
  { id: "10mins", label: "Last 10 minutes" },
  { id: "30mins", label: "Last 30 minutes" },
  { id: "1hour", label: "Last 1 hour" },
  { id: "2hours", label: "Last 2 hours" },
  { id: "12hours", label: "Last 12 hours" },
  { id: "1day", label: "Last day" },
  { id: "2days", label: "Last 2 days" },
])
